import { PaymentModel } from '@/payment/models/PaymentModel';

interface PaymentDetails {
    [key:string]: any;
    type?:string;
}

export class OrderPaymentModel {
    installments?: number;
    idPayment: string = "";
    idExternalChannel: string = "";
    details: string|PaymentDetails|null = "";
    nsuCode: string = "";
    authorizationNumber: string = "";
    value: number = 0;
    changeValue: number = 0;    
    payment: PaymentModel = new PaymentModel();

    constructor(op?: Partial<OrderPaymentModel>) {
        Object.assign(this, op);

        this._parsePayment();
    }

    hasInstallments():boolean {
        if (!this.installments) {
            return false
        }

        return this.installments > 0;
    }

    hasChangeValue():boolean {
        return this.changeValue > 0;
    }

    hasNsuCode():boolean {
        return !!this.nsuCode
    }

    hasAuthorizationNumber():boolean {
        return !!this.authorizationNumber
    }

    hasDetails():boolean {
        return !!this.details
    }

    getDetails():string {
        if (!this.details) {
            return ''
        }

        if (typeof this.details === "string") {
            return this.details
        }

        if (typeof this.details === "object") {
            if (!!(this.details as PaymentDetails).type) {
                return `${(this.details as PaymentDetails).type}`
            }
        }

        return ''
    }

    private _parsePayment():void {
        this.payment = new PaymentModel(this.payment);
    }
}
